import React, { Component } from 'react';

import Basket from './basket.js';
import KindMake from './kinds/kind-make.js';
import Sort from './sort.js';
import CONFIG from "../config.js";
import Timeout from "../utils/components/Timeout";

export default class Panel extends Component {
  render() {
    let orders = [
      { id: "popularity-asc", name: "Beliebtheit" },
      { id: "name-asc", name: "Name (A-Z)" },
      { id: "name-desc", name: "Name (Z-A)" }
    ];
    if (CONFIG.isEdelmetallShop()) {
      orders = [
        { id: "popularity-asc", name: "Beliebtheit" },
        { id: "price-asc", name: "Preis aufsteigend" },
        { id: "price-desc", name: "Preis absteigend" },
        { id: "name-asc", name: "Name (A-Z)" },
        { id: "name-desc", name: "Name (Z-A)" }
      ];
    }
    return (
      <div>
        <Timeout />
        <h3 className="aria-visible">Auswahl</h3>
        <Basket />
        {CONFIG.isEdelmetallShop()
          ? <section aria-label="Auswahlkriterien">
            <KindMake />
          </section>
          : null
        }
        <section aria-label="Anzeigekriterien">
          <Sort orders={orders} />
        </section>
      </div>
    );
  }
}
